export function normalizeSource(value: string): string {
  return value.trim().replace(/\s+/g, ' ').toLowerCase();
}

export function hashSource(value: string): string {
  const normalized = normalizeSource(value);
  let hash = 5381;
  for (let index = 0; index < normalized.length; index += 1) {
    hash = (hash * 33) ^ normalized.charCodeAt(index);
  }
  return `src_${(hash >>> 0).toString(16)}`;
}

export function nowIso(): string {
  return new Date().toISOString();
}

export function id(prefix: string): string {
  return `${prefix}_${Math.random().toString(36).slice(2, 9)}_${Date.now().toString(36)}`;
}
